<!-- routify:options title='E-mail' -->
<!-- routify:options index=1 -->
<!-- routify:options showInNavigation=true -->

<script>
    import { fetchJSON } from '../../../common/Backend'
    import { scrollToTop } from '../../../common/Utils'
    import { t } from 'totalinvoice-frontend-core'
    import { Button, Notification, ServerErrorNotification }  from 'totalinvoice-frontend-core'
    import { STATUS_NONE, STATUS_PROCESSING, STATUS_SUCCESS, STATUS_SERVER_ERROR } from 'totalinvoice-frontend-core'
    import { languages } from 'totalinvoice-frontend-core'

    let status = STATUS_NONE

    let error = ''
    let showServerErrorNotification = false
    $: showServerErrorNotification = status === STATUS_SERVER_ERROR

    let customer = ''
    let showSuccessNotification = false
    $: showSuccessNotification = status === STATUS_SUCCESS

    const email = {
        invoiceRequestId: 0,
        type: 'invoice-request-finished',
        language: 'fr',
    }

    async function send() {
        status = STATUS_PROCESSING
        const res = await fetchJSON("email", { ...email })
        if (res.status === 'ok') {
            status = STATUS_SUCCESS
            customer = res.data
        } else {
            status = STATUS_SERVER_ERROR
            error = res
        }
        scrollToTop()
    }
</script>

<h2 class="title is-2 is-spaced page-title">{$t('Send e-mail to customer')}</h2>

{#if showServerErrorNotification}
    <ServerErrorNotification bind:active={showServerErrorNotification} {error} />
{/if}

{#if showSuccessNotification}
    <Notification type='is-success' bind:active={showSuccessNotification} icon={true}>
        <strong>{$t('E-Mail sent successfully.')}<br></strong>
        <div class="mt-3">
            {$t('Customer')}: {customer.id}<br>
            {$t('E-mail')}: {customer.email}
        </div>
    </Notification>
{/if}

<div class="field is-horizontal">
    <div class="field-label is-normal">
        <label for class="label">{$t('E-mail type')}</label>
    </div>
    <div class="field-body">
        <div class="field is-narrow">
            <div class="control">
                <div class="select is-fullwidth">
                    <select bind:value={email.type}>
                        <option value="invoice-request-finished">{$t('Invoice request finished')}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="field is-horizontal">
    <div class="field-label is-normal">
        <label for class="label">{$t('Invoice request')}</label>
    </div>
    <div class="field-body">
        <div class="field">
            <p class="control is-expanded">
                <input class="input" type="text" bind:value={email.invoiceRequestId}>
            </p>
            <p class="help">{$t('Invoice request ID')}</p>
        </div>
    </div>
</div>

<div class="field is-horizontal">
    <div class="field-label is-normal">
        <label for class="label">{$t('Language')}</label>
    </div>
    <div class="field-body">
        <div class="field is-narrow">
            <div class="control">
                <div class="select is-fullwidth">
                    <select bind:value={email.language}>
                        {#each languages as lang}
                            <option value={lang.iso}>{lang.iso}</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="field is-horizontal">
    <div class="field-label"></div>
    <div class="field-body">
        <div class="field">
            <div class="control">
                <Button type='is-link'
                        loading={status === STATUS_PROCESSING}
                        on:click={send}>
                    {$t('Send')}
                </Button>
            </div>
        </div>
    </div>
</div>
